import { useDebounce } from '@dwarvesf/react-hooks';
import InputAdornment from '@mui/material/InputAdornment';
import React, {
  forwardRef,
  memo,
  useCallback,
  useState,
  useEffect,
  useRef
} from 'react';

import KInput from './TextField';

import KImage from '../Image';
import { KInputProps } from '../types';

interface KInputSearchProps extends KInputProps {
  initKeyword?: string;
  wait?: number;
}

const KInputSearch = forwardRef((props: KInputSearchProps, ref) => {
  const { initKeyword = '', wait = 800, onChange, ...otherProps } = props;

  const [keyword, setKeyword] = useState(initKeyword);

  const debounceKeyword = useDebounce(keyword, wait);

  const mounted = useRef(false);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
    } else {
      onChange?.({ target: { value: debounceKeyword } } as any);
    }
  }, [debounceKeyword, onChange]);

  const onChangeWrapper = useCallback((e: any) => {
    setKeyword(e.target.value);
  }, []);

  return (
    <KInput
      ref={ref as any}
      name="keyword"
      placeholder="Search"
      br="2x"
      brW={1}
      brC="#e2e8f0"
      background="white"
      {...otherProps}
      value={keyword}
      onChange={onChangeWrapper}
      InputProps={{
        startAdornment: (
          <InputAdornment position="end">
            <KImage.MuiIcon icon="Search" />
          </InputAdornment>
        )
      }}
    />
  );
});

export default memo(KInputSearch);
